export const employeePhoneShowMore = (): void => {
  const allemployeeBlocks = document.querySelectorAll('.js-employees') as unknown as HTMLElement[]

  allemployeeBlocks.forEach((employeeBlock: HTMLElement) => {
    const phoneShowMoreButton = employeeBlock.querySelector('.js-employees-phoneShowMoreButton') as unknown as HTMLElement

    phoneShowMoreButton.addEventListener('click', (e: Event): void => {
      setTimeout(() => {
        phoneShowMoreButton.remove()
        employeeBlock.classList.add('-showAll')
      }, 150)
    })
  })
}
